(function (angular) {
    'use strict';

    angular.module('appMessaging')
        /**
         *
         */
        .controller('ClientPermissionsCtrl',
            ['$scope', 'clientPermissionsService', 'clientPermissionsData', '$stateParams', '$uibModal', '$state' ,'growlService',
                function ($scope, clientPermissionsService, clientPermissionsData, $stateParams, $uibModal, $state, growlService) {
        }]);


})(window.angular);
